import logger from '@tcp/core/src/utils/loggerInstance';
import handler from '../../handler';

const Abstractor = {
  getData: (module, data, apiConfig) => {
    return handler
      .fetchModuleDataFromGraphQL({ name: module, data }, apiConfig)
      .then((response) => response.data)
      .catch((error) => {
        logger.error('Error in fetching Category Page SeoData', {
          error,
          extraData: {
            component: 'catSeoData - index',
            payloadRecieved: data,
          },
        });
        return {
          categorySeoData: {
            seoTitle: '',
            seoMetaDesc: '',
            seoCanonicalUrl: '',
            longDescription: '',
            seoHeaderCopy: '',
          },
        };
      });
  },
};

export default Abstractor;
